import { comments } from "@/mocks/articles";

export default function TestimonialSection() {
  const testimonial = comments[4]; // Use the marriage counselor comment

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
            {/* Left - Quote */}
            <div>
              <div className="flex items-center gap-2 mb-6">
                <span className="w-2 h-2 rounded-full bg-foreground-950" />
                <span className="text-foreground-700 text-sm font-medium">瓜友热评</span>
              </div>

              <blockquote className="mb-8">
                <p className="font-heading text-foreground-950 text-2xl md:text-3xl lg:text-4xl leading-snug mb-6">
                  <span className="text-primary-500">"</span>
                  {testimonial.content}
                  <span className="text-primary-500">"</span>
                </p>
              </blockquote>

              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-secondary-200 flex items-center justify-center">
                  <i className="ri-user-3-line text-secondary-600 text-lg" />
                </div>
                <div>
                  <p className="font-bold text-foreground-950 text-sm">
                    {testimonial.author}
                    <i className="ri-verified-badge-fill text-green-500 ml-1.5 text-sm" />
                  </p>
                  <p className="text-foreground-500 text-xs">{testimonial.date}</p>
                </div>
              </div>
            </div>

            {/* Right - Image */}
            <div className="hidden lg:block">
              <div className="rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=artistic%20black%20and%20white%20portrait%20photography%2C%20mysterious%20figure%20silhouette%2C%20dramatic%20side%20lighting%2C%20high%20contrast%2C%20elegant%20minimal%20composition%2C%20editorial%20style%20portrait%2C%20clean%20white%20background&width=800&height=600&seq=testimonial-portrait&orientation=landscape"
                  alt="瓜友热评"
                  className="w-full aspect-[4/3] object-cover object-top grayscale"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}